{
  "familyId": "TOPO-NL-PROV",
  "questions": [
    {
      "id": "TOPO-NL-PROV-TF-001",
      "familyId": "TOPO-NL-PROV",
      "module": "Topografie",
      "tier": 7,
      "levelCode": "M6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "nl_provincies",
      "questionType": "true_false_series",
      "question": "Zijn deze stellingen over Nederlandse provincies waar of onwaar?",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "statements": [
          {
            "text": "Groningen ligt in het noorden van Nederland.",
            "isTrue": true
          },
          {
            "text": "Zeeland grenst aan Duitsland.",
            "isTrue": false
          },
          {
            "text": "Limburg is de meest zuidelijke provincie.",
            "isTrue": true
          },
          {
            "text": "Utrecht is de grootste provincie van Nederland.",
            "isTrue": false
          },
          {
            "text": "Friesland ligt aan de Waddenzee.",
            "isTrue": true
          }
        ]
      },
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "nl_provincies"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Nederlandse provincies",
            "content": "Nederland heeft 12 provincies. Groningen, Friesland en Noord-Holland liggen in het noorden. Zeeland ligt in het zuidwesten en grenst aan België. Limburg ligt in het zuidoosten. Utrecht is een kleine provincie in het midden.",
            "icon": "map"
          }
        }
      ],
      "conceptId": "nl_provinces_facts",
      "variantIndex": 1,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Groningen ligt inderdaad in het noorden. Zeeland grenst aan België, niet aan Duitsland. Limburg is de meest zuidelijke provincie. Utrecht is juist een van de kleinste provincies. Friesland ligt aan de Waddenzee.",
        "solutionSteps": [
          "Groningen in het noorden: Waar ✓",
          "Zeeland grenst aan België, niet Duitsland: Onwaar",
          "Limburg meest zuidelijk: Waar ✓",
          "Utrecht is klein, niet groot: Onwaar",
          "Friesland aan de Waddenzee: Waar ✓"
        ]
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": []
      }
    },
    {
      "id": "TOPO-NL-PROV-TF-002",
      "familyId": "TOPO-NL-PROV",
      "module": "Topografie",
      "tier": 7,
      "levelCode": "M6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "nl_provincies",
      "questionType": "true_false_series",
      "question": "Zijn deze stellingen over Nederlandse provincies waar of onwaar?",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "statements": [
          {
            "text": "Noord-Holland en Zuid-Holland zijn twee verschillende provincies.",
            "isTrue": true
          },
          {
            "text": "Drenthe ligt aan zee.",
            "isTrue": false
          },
          {
            "text": "Gelderland grenst aan Duitsland.",
            "isTrue": true
          },
          {
            "text": "Flevoland is de oudste provincie van Nederland.",
            "isTrue": false
          }
        ]
      },
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "nl_provincies"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Provincies en hun ligging",
            "content": "Noord-Holland en Zuid-Holland zijn inderdaad twee aparte provincies. Drenthe ligt in het binnenland, niet aan zee. Gelderland grenst in het oosten aan Duitsland. Flevoland is juist de jongste provincie (1986), gewonnen op de Zuiderzee.",
            "icon": "map"
          }
        }
      ],
      "conceptId": "nl_provinces_location",
      "variantIndex": 2,
      "citoDifficulty": 0.3,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Noord-Holland en Zuid-Holland zijn twee aparte provincies. Drenthe ligt in het binnenland. Gelderland grenst aan Duitsland. Flevoland is de jongste provincie (1986), niet de oudste.",
        "solutionSteps": [
          "Noord-Holland en Zuid-Holland zijn apart: Waar ✓",
          "Drenthe ligt in het binnenland: Onwaar",
          "Gelderland grenst aan Duitsland: Waar ✓",
          "Flevoland is de jongste provincie: Onwaar"
        ]
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": []
      }
    }
  ]
}